<template>
  <div class="box-worksDisplayCards hover-change-color" @click="submitButton(info.id)">
    <p>
      {{ info.title }}
      <!-- 有人说:“老师是座灯塔，为我们照亮前方的道路;老师像只蜡烛，燃烧了自己，却成为照亮别人的人。”还有人说:“老师是辛勤的园丁，用自己的心血和汗水浇灌着我们。 -->
    </p>
    <!-- <el-tag>{{ info.activity_type }}</el-tag> -->
    <div class="icon-box">
      <!-- <el-icon><User /></el-icon> -->
      <el-icon><Position /></el-icon>
      <p>
        文章来源：
        <span>
          {{ info.source }}
        </span>
      </p>
    </div>
    <div class="icon-box">
      <el-icon><User /></el-icon>
      <p>
        作者：
        <span> {{ info.author }} </span>
      </p>
    </div>
    <div class="icon-box">
      <el-icon><Calendar /></el-icon>
      <p>
        上传时间：
        <span>
          {{ dayjs(info.release_time * 1000).format("YYYY-MM-DD") }}
          <!-- {{ dayjs(info.start_time * 1000).format("YYYY-MM-DD") }}~{{
                    dayjs(info.end_time * 1000).format("YYYY-MM-DD")
                  }} -->
        </span>
      </p>
      <!-- <p>
        发布时间：
        <span> {{ dayjs(info.start_time * 1000).format("YYYY-MM-DD") }}~{{ dayjs(info.end_time * 1000).format("YYYY-MM-DD") }} </span>
      </p> -->
    </div>
  </div>
</template>

<script setup>
import { Calendar } from "@element-plus/icons-vue";
import { User,Position } from "@element-plus/icons-vue";
import { reactive } from "vue";

import dayjs from "dayjs";

import { useRouter, useRoute } from "vue-router";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.box-worksDisplayCards {
   width: 343px;
  // height: 228px;
  border-radius: 20px;
  padding: 16px;
  //   border: 1px solid red;
  background-color: #ffffff;


  cursor: pointer;
  > p {
    font-size: 16px;
    font-weight: 700;
    height: 48px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
    text-overflow: ellipsis; //文本溢出 用省略号显示
    -webkit-line-clamp: 2; //几行
    overflow: hidden;

    cursor: pointer;
  }
  .el-tag {
    height: 32px;
    background: #cff1ff;
    color: #009de0;
    font-size: 14px;
    // border: 1px solid #c5cbce;
    margin-top: 12px;
    margin-left: 0px;
    padding: 5px 10px;
  }
  .icon-box {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    margin-bottom: 8px;
    p {
      margin-left: 8px;
    }
  }
  .icon-box:nth-of-type(1) {
    margin-top: 24px;
  }
}
</style>